// @flow
/** @jsx jsx */

import { Heading } from '@zapier/legacy-components';
import { jsx } from '@emotion/core';
import { HeadingLevel, Text } from '@zapier/common-components';

import ZapMoverFolder from 'app/zap-mover/components/FilterableZapsList/ZapMoverFolder';

import type {
  FolderType,
  OnChooseFolderType,
  OnChooseZapType,
} from 'app/zap-mover/types';

type Props = {
  folders: Array<FolderType>,
  isOpen: boolean,
  isSingleSelect: boolean,
  onChooseFolder: OnChooseFolderType,
  onChooseZap: OnChooseZapType,
  title: string,
};

const listCss = {
  marginBottom: 0,
};

const sectionTitleCss = {
  margin: '15px 0 0 15px',
};

const ZapMoverSection = ({
  folders,
  isOpen,
  isSingleSelect,
  onChooseFolder,
  onChooseZap,
  title,
}: Props) => {
  return folders.length > 0 ? (
    <section>
      <HeadingLevel>
        <Heading css={sectionTitleCss}>
          <Text type="subsection-head">{title}</Text>
        </Heading>
      </HeadingLevel>
      <ul css={listCss}>
        {folders.map(folder => (
          <ZapMoverFolder
            {...folder}
            isOpen={isOpen}
            isSingleSelect={isSingleSelect}
            key={folder.id}
            onChooseFolder={onChooseFolder}
            onChooseZap={onChooseZap}
          />
        ))}
      </ul>
    </section>
  ) : null;
};

export default ZapMoverSection;
